<template>
  <input ref="textField"
         class="c-textField"
         autocomplete="on"
         :name="name"
         :value="modelValue"
         :placeholder="placeholder"
         @input="$emit('update:modelValue', $event.target.value)"
  >
</template>

<script>
export default {
  name: 'TextField',
  props: {
    name: String,
    modelValue: String,
    placeholder: String,
  },
  emits: ['update:modelValue']
}
</script>
